import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  resetStatusPph,
  // sendDocumentPph,
  updateUrlPph,
} from "features/common/layouts/cartSlice";
import { Modal } from "react-bootstrap";
import { notifyError, notifySuccess } from "components/ToastMessage";
// import styles from "../../assets/scss/ModalPph.module.scss";

const ModalPph = (props) => {
  const dispatch = useDispatch();
  // const { status_login } = useSelector((state) => state.auth);
  const { documentPph } = useSelector((state) => state.cart);
  // const [loading, setLoading] = useState(false);
  // const [buttonDisable, setButtonDisable] = useState(false);
  // const [sendFile, setSendFile] = useState("");

  const handlerLengkapiNanti = () => {
    props.onHide();
    dispatch(updateUrlPph("Lengkapi Nanti"));
  };

  // const handleFileChange = (event) => {
  //   const imageFile = event.target.files[0];
  //   setSendFile(imageFile);
  // };

  // const handlerSendPph = (event) => {
  //   event.preventDefault();

  //   if (!sendFile) {
  //     notifyWarning("Foto NPWP Anda Belum Terisi!");
  //     return;
  //   }

  //   if (sendFile.size > 2 * 1024 * 1024) {
  //     notifyError(
  //       "Harap periksa ukuran file Anda. Ukuran maksimal yang diperbolehkan adalah 2MB."
  //     );
  //     return;
  //   }

  //   if (
  //     sendFile.type !== "image/jpg" &&
  //     sendFile.type !== "image/png" &&
  //     sendFile.type !== "image/jpeg" &&
  //     sendFile.type !== "application/pdf"
  //   ) {
  //     notifyError(
  //       "Maaf, hanya file dengan ekstensi PDF, PNG, JPG, dan JPEG yang diperbolehkan."
  //     );
  //     return;
  //   }

  //   setButtonDisable(true);
  //   setLoading(true);

  //   if (sendFile) {
  //     if (status_login) {
  //       dispatch(sendDocumentPph(sendFile));
  //     } else {
  //       notifyError("Anda belum login!");
  //     }
  //   }
  // };

  useEffect(() => {
    if (documentPph.status === "fulfilled") {
      notifySuccess("Kelengkapan Document Pph 23 Berhasil di Upload");
      dispatch(resetStatusPph("idle"));
      props.onHide();
    } else if (documentPph.status === "error") {
      notifyError(`${documentPph.error}`);
      dispatch(resetStatusPph("idle"));
    }
  }, [dispatch, documentPph.status, documentPph.error, props]);

  return (
    <>
      <Modal show={props.show} onHide={props.onHide} backdrop="static" centered>
        <Modal.Header closeButton>
          <Modal.Title>Pemotongan PPH 23</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form">
            <p className="mt-2" style={{ fontSize: "16px" }}>
              Bukti Potong PPH23 wajib di lampirkan{" "}
              <a
                href={`${process.env.REACT_APP_BASE_API}index.php?m=document_pph`}
                target="_blank"
                rel="noopener noreferrer"
              >
                disini
              </a>
              , apabila tidak mengupload lebih dari <strong>45 hari</strong>{" "}
              maka sistem akan mengambil otomatis kekurangan dari bukti potong
              yang dibatalkan dari deposit anda Atau Sistem akan mensuspend
              layanan anda
            </p>
          </div>
          <div className="d-flex flex-row gap-3 mt-4">
            <button
              className="btn btn-modal-login w-100"
              type="button"
              onClick={handlerLengkapiNanti}
            >
              Lanjutkan
            </button>
            {/* <button className='btn btn-modal-login w-100' disabled={buttonDisable} type='submit'>{loading ? <Spinner animation="border" size="sm" /> : 'Simpan'}</button> */}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalPph;
